export enum USER_ROLES {
	SUPER_ADMIN = 'super_admin',
	ADMIN = 'admin',
	USER = 'user',
	GUEST = 'guest',
}
